/**
 * Group items in an array by a callback or key
 * @param  {array}              arr array to group items
 * @param  {string || callback} key lookup key or callback to use to group
 * @return {object}                 item with grouped objects
 */
export default function groupBy(arr, key) {
  return arr.reduce((acc, item) => {
    const tmp = key instanceof Function ? key(item) : item[key];
    const ret = acc[tmp] || [];
    ret.push(item);
    return { ...acc, [tmp]: ret };
  }, {});
}



// WEBPACK FOOTER //
// ./app/utils/array/groupBy.js